import React from "react";
import Placeholder from "../Placeholder";

function CaseItemTitlePlaceholder(data) {
    return (
        <h2 className="title title--h3">
            <Placeholder style={{ height: "30px", width: "200px" }} />
        </h2>
    );
}
export default CaseItemTitlePlaceholder;